import { Box } from '@mui/material'
import { getTeamsTable } from 'api/teams'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import TableToolbar from 'components/table/TableToolbar'
import { useExportCSV } from 'hooks/useExportCSV'
import { useGridControl } from 'hooks/useGridControl'
import React, { ReactNode, useCallback } from 'react'
import { AdminCareTeamsRequest, AdminCareTeamsScope, BaseTableRequest } from 'types'
import { useGetDataSource } from 'utils'
import { useFamilyCaregiverTeamsPageColumns } from './useFamilyCaregiverTeamsPageColumns'

export function FamilyCaregiverTeamsPage({ toolbarLeft }: { toolbarLeft?: ReactNode }) {
  const getApiWrapper = useCallback((req: BaseTableRequest) => {
    const request: AdminCareTeamsRequest = {
      ...req,
      params: { scope: AdminCareTeamsScope.familyCaregiver },
    }
    return getTeamsTable(request)
  }, [])

  const getDataSource = useGetDataSource(getApiWrapper)
  const { onGridReady, gridApi, columnApi } = useGridControl(getDataSource)
  const { columnDefs, csvFields } = useFamilyCaregiverTeamsPageColumns()

  const { csvLoading, onExportCSV } = useExportCSV(
    getApiWrapper,
    gridApi,
    columnApi,
    csvFields,
    'Family Caregiver Teams.csv',
  )

  return (
    <>
      <TableToolbar
        title=""
        left={toolbarLeft}
        exportCSVEnable
        csvLoading={csvLoading}
        onExportCSV={onExportCSV}
      />

      <Box mb={2} height="100%">
        <InfinityAgGrid pagination columnDefs={columnDefs} onGridReady={onGridReady} />
      </Box>
    </>
  )
}
